import type { ReactNode } from 'react';
import { CaretRight } from '@phosphor-icons/react';
import { ConnectionPrivacyButton } from '../IntegrationDisclosure';
import { Tooltip } from '@common/index';

export interface ConnectionTrustBadge {
  id: string;
  label: string;
  description: string;
  icon: ReactNode;
}

interface ConnectionTrustTagsProps {
  badges: ConnectionTrustBadge[];
  isPlugin?: boolean;
  showPrivacyLink?: boolean;
}

const ConnectionTrustTags = ({ badges, isPlugin = false, showPrivacyLink = true }: ConnectionTrustTagsProps) => (
  <div
    data-connection-trust-summary="true"
    className="flex max-w-full flex-wrap items-center gap-2"
  >
    {badges.map((badge) => (
      <Tooltip
        key={badge.id}
        variant="light"
        side="bottom"
        sideOffset={8}
        align="center"
        content={(
          <p className="text-[12px] leading-[18px] text-[#59627D]">{badge.description}</p>
        )}
      >
        <span
          data-connection-trust-badge={badge.id}
          tabIndex={0}
          className="inline-flex max-w-full items-center gap-1.5 rounded-full bg-[#EBEDF3] px-3 py-1.5 text-left text-[13px] leading-5 text-[#66708D] transition-colors hover:bg-[#E1E5EE] hover:text-[#1A162F] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1A162F]/25"
        >
          <span className="shrink-0" aria-hidden="true">{badge.icon}</span>
          <span>{badge.label}</span>
          <CaretRight size={13} weight="regular" className="shrink-0 text-[#8A93B2]" aria-hidden="true" />
        </span>
      </Tooltip>
    ))}
    {showPrivacyLink ? <ConnectionPrivacyButton isPlugin={isPlugin} /> : null}
  </div>
);

export default ConnectionTrustTags;
